import React, { MutableRefObject, useEffect, useState } from 'react';
import TableStatus from './TableStatus';
import ViewDetails from './ViewDetails';

import { UserUploadHistory, UserUploadStage } from '../../../models/ApiResponseModels/UserUploadHistoryResponseModel';

interface UploadTableProps {
    importHistory: UserUploadHistory[]
    cancelOrCompleteRef: MutableRefObject<{ [key: number]: "cancel" | "complete" }>
}

const UploadTable = ({importHistory, cancelOrCompleteRef }:UploadTableProps) => { 
    const [refresh, setRefresh] = useState<boolean>(false)

    useEffect(() => {
        // a bit of a hack to refresh this component from the view detials child component
        refresh && setRefresh(false)
    },[refresh])

    function getStatus(id, status) {
        if (cancelOrCompleteRef.current && cancelOrCompleteRef.current[id]) {
            return cancelOrCompleteRef.current[id] === 'cancel' ? UserUploadStage.Cancelling : UserUploadStage.Completing
        }
        return status
    }

    function getRowCount(index: number) {
        const {totalLinesInFile} = importHistory[index]
        return totalLinesInFile;
    }

    function getType(index: number) {
        return importHistory[index].userImportType;
    }

    function formatDateTime(dateString: string): string {
        const date = new Date(dateString)
        const formattedDate = date.toLocaleDateString(navigator.language, {
            year: "2-digit",
            month: "2-digit",
            day: "2-digit",
           
        }).replace(/ /g, '-');

        const time = date.toLocaleTimeString(navigator.language, {
            hour: "2-digit",
            minute: "2-digit",
            hourCycle: 'h23',
        });

        return `${formattedDate} ${time}`
    }

    if (!importHistory || importHistory.length === 0) {
        return (<>
            <p>You have not yet uploaded any documents</p>
            <p>Please select Import User CSV File to upload your first file</p>
        </>)
    }

    return (
    <table className="table table-striped table-user-upload" id="Items">
    <thead>
        <tr>
            <th>
                Date/Time
            </th>
            <th>
                File Name
            </th>
            <th>
                Lines
            </th>
            <th>
                Type
            </th>
            <th>
                Status
            </th>
            <th></th>
        </tr>
    </thead>
    <tbody>
        {importHistory.map(({fileName, createDate, status, id, comparisonCompletedAt, groupImportAvailable, groupImportCompleted, groupsAdded }, index) => (
           <tr key={`table-row-${index + 1}`}>
                <td>
                    {formatDateTime(createDate)}
                </td>
                <td className='filename-field'>
                    {index <= 2
                        ? <a href={`/api/UserImport/DownloadOriginal/${id}`} target="blank">{fileName}</a>
                        : <span>{fileName}</span>
                    }
                </td>
                <td>
                    {getRowCount(index)}
                </td>
                <td>
                    {getType(index)}
                </td>
                <td>
                    <TableStatus status={getStatus(id, status)} pendingRequestStatus={!comparisonCompletedAt} />
                </td>
                <td >
                    <ViewDetails
                        id={id}
                        setRefresh={setRefresh}
                        status={getStatus(id, status)}
                        isInFlight={!comparisonCompletedAt}
                        fileName={fileName}
                        cancelOrCompleteRef={cancelOrCompleteRef}
                    />
                </td>
            </tr>
        ))}
    </tbody>
</table>
)};

export default UploadTable;

